import React, {useState} from 'react'
import { useDispatch } from 'react-redux'
import { useAppSelector } from '../../../hooks/useAppSelector'
import { dataSlice } from '../../../redux/slices'
import '../Search/FileExtensionList.css'

export const TypeSelectAll: React.FC = () => {
  const [expandList, setExpandList] = useState(false);
  const fileTypes = useAppSelector((state) => state.data.fileTypes)

  // Only render if fileTypes is not empty
  if (Object.keys(fileTypes).length === 0) {
    return <></>
  }

  return (
    <div className='dg-file-ext-container'>
      <label className="ext-select-all-label">Select All</label>
      <div className={`dg-file-ext-list results-file-ext-list ${expandList ? 'expanded-ext-list' : ''}`}>
        <div style={{fontSize: "14px", width: "100%", height: "30px"}} className={`expand-ext-list-action chevron`} aria-label="expandlist" tabIndex={0} role="button" onClick={(e) => {e.preventDefault(); setExpandList(!expandList)}}>
          <span style={{color: '#999'}}>Choose Extensions</span>
          <i className={expandList ? "dx-icon dx-icon-chevronup" : "dx-icon dx-icon-chevrondown"}></i>
        </div>
        {Object.keys(fileTypes).map((i) => {
          return <_TypeRow key={`TypeSelectAllRow${i}`} fileType={i} />
        })}
      </div>
      <div style={{fontSize: "14px"}} className={`expand-ext-list-action ellipsis`} aria-label="expandlist" tabIndex={0} role="button" onClick={(e) => {e.preventDefault(); setExpandList(!expandList)}}>
          <i className={expandList ? "dx-icon dx-icon-chevronleft" : "dx-icon dx-icon-more"}></i>
          <span className="expand-list-tooltip">Show more</span>
      </div>
    </div>
  )
}

export const _TypeRow: React.FC<{ fileType: string }> = ({ fileType }) => {
  const selected = useAppSelector((state) => state.data.fileTypes[fileType])
  const dispatch = useDispatch()

  return (
    <button
      onClick={() => dispatch(dataSlice.actions.toggleType(fileType))}
      className={`dg-ext-btn ${selected ? 'active' : ''}`}
    >
      <div className="dg-ext-btn-text">{fileType}</div>
    </button>
  )
}
